import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../constants/routing/NavItems';
const productLineToNavItemMap = {
  [CMS]: NavItemEnum.CONTENT,
  [MARKETING]: NavItemEnum.MARKETING,
  [OPERATIONS]: NavItemEnum.OPERATIONS,
  [SALES]: NavItemEnum.SALES,
  [SERVICE]: NavItemEnum.SERVICE,
  [COMMERCE]: NavItemEnum.COMMERCE
};
export const getNavItemForProductLine = (__, productLine) => {
  return productLineToNavItemMap[productLine];
};